import { Component, OnInit } from '@angular/core';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { ReportService } from 'src/app/_service/report.service';

@Component({
  selector: 'user-report',
  templateUrl: './user-report.component.html',
  styleUrls: ['./user-report.component.css']
})
export class UserReportComponent implements OnInit {

  checkAll = false;
  firstName;
  firstNameChecked = false;
  lastName;
  lastNameChecked = false;
  contactName;
  contactNameChecked = false;
  address1;
  addressChecked1 = false;
  address2;
  addressChecked2 = false;
  city;
  cityChecked = false;
  province;
  provinceChecked = false;
  country;
  countryChecked = false;
  postalCode;
  postalCodeChecked = false;
  phone;
  phoneChecked = false;
  fax;
  faxChecked = false;
  email;
  emailChecked = false;
  userName;
  userNameChecked = false;

  authorities;
  authoritiesChecked = false;
  role;
  roleChecked = false;
  creationDate;
  creationDateChecked = false;
  notes;
  notesChecked = false;

  loading = false;
  isLoading = false;

  report;

  selectionRequired: any = {};

  constructor(
    private alertify: AlertifyService,
    private reportService: ReportService
  ) { }

  ngOnInit() {
  }

  onSelectAllClick(event) {
    if (event.checked) {
      this.firstNameChecked = true;
      if (this.firstNameChecked) {
        this.onFirstnameChecked();
      }
      this.lastNameChecked = true;
      if (this.lastNameChecked) {
        this.onLastNameChecked();
      }
      this.contactNameChecked = true;
      if (this.contactNameChecked) {
        this.onContactNameChecked();
      }
      this.addressChecked1 = true;
      if (this.addressChecked1) {
        this.onAddressChecked1();
      }
      this.addressChecked2 = true;
      if (this.addressChecked2) {
        this.onAddressChecked2();
      }
      this.cityChecked = true;
      if (this.cityChecked) {
        this.onCityChecked();
      }
      this.provinceChecked = true;;
      if (this.provinceChecked) {
        this.onProvinceChecked();
      }
      this.countryChecked = true;
      if (this.countryChecked) {
        this.onCountryChecked();
      }
      this.postalCodeChecked = true;
      if (this.postalCodeChecked) {
        this.onPostalCodeChecked();
      }
      this.phoneChecked = true;
      if (this.phoneChecked) {
        this.onPhoneChecked();
      }
      this.faxChecked = true;
      if (this.faxChecked) {
        this.onFaxChecked();
      }
      this.emailChecked = true;
      if (this.emailChecked) {
        this.onEmailChecked();
      }
      this.userNameChecked = true;
      if (this.userNameChecked) {
        this.onUserNameChecked();
      }
      this.authoritiesChecked = true;
      if (this.authoritiesChecked) {
        this.onAuthoritiesChecked();
      }
      this.roleChecked = true;
      if (this.roleChecked) {
        this.onRoleChecked();
      }
      this.creationDateChecked = true;
      if (this.creationDateChecked) {
        this.onCreationDateChecked();
      }
      this.notesChecked = true;
      if (this.notesChecked) {
        this.onNotesChecked();
      }
    } else {
      this.firstNameChecked = false;
      this.firstName = '';
      this.lastNameChecked = false;
      this.lastName = '';
      this.contactNameChecked = false;
      this.contactName = '';
      this.addressChecked1 = false;
      this.address1 = '';
      this.addressChecked2 = false;
      this.address2 = '';
      this.cityChecked = false;
      this.city = '';
      this.provinceChecked = false;
      this.province = '';
      this.countryChecked = false;
      this.country = '';
      this.postalCodeChecked = false;
      this.postalCode = '';
      this.phoneChecked = false;
      this.phone = '';
      this.faxChecked = false;
      this.fax = '';
      this.emailChecked = false;
      this.email = '';
      this.userNameChecked = false;
      this.userName = '';
      this.authoritiesChecked = false;
      this.authorities = '';
      this.roleChecked = false;
      this.role = '';
      this.creationDateChecked = false;
      this.creationDate = '';
      this.notesChecked = false;
      this.notes = '';
    }
  }

  onFirstnameChecked() {
    this.firstName = '';
    if (this.firstNameChecked) {
      this.firstName = 'FirstName';
    }
  }

  onLastNameChecked() {
    this.lastName = '';
    if (this.lastNameChecked) {
      this.lastName = 'LastName';
    }
  }

  onContactNameChecked() {
   this.contactName = '';
    if (this.contactNameChecked) {
      this.contactName = 'ContactName';
    }
  }

  onAddressChecked1() {
    this.address1 = '';
    if (this.addressChecked1) {
      this.address1 = 'Address1';
    }
  }
  
  onAddressChecked2() {
    this.address2 = '';
    if (this.addressChecked2) {
      this.address2 = 'Address2';
    }
  }

  onCityChecked() {
    this.city = '';
    if (this.cityChecked) {
      this.city = 'City';
    }
  }

  onProvinceChecked() {
    this.province = '';
    if (this.provinceChecked) {
      this.province = 'Province';
    }
  }

  onCountryChecked() {
    this.country = '';
    if (this.countryChecked) {
      this.country = 'Country';
    }
  }

  onPostalCodeChecked() {
    this.postalCode = '';
    if (this.postalCodeChecked) {
      this.postalCode = 'PostalCode';
    }
  }

  onPhoneChecked() {
    this.phone = '';
    if (this.phoneChecked) {
      this.phone = 'Phone';
    }
  }

  onFaxChecked() {
    this.fax = '';
    if (this.faxChecked) {
      this.fax = 'Fax';
    }
  }

  onEmailChecked() {
    this.email = '';
    if (this.emailChecked) {
      this.email = 'Email';
    }
  }

  onUserNameChecked() {
    this.userName = '';
    if (this.userNameChecked) {
      this.userName = 'UserName';
    }
  }

  onAuthoritiesChecked() {
    this.authorities = '';
    if (this.authoritiesChecked) {
      this.authorities = 'Authorities';
    }
  }

  onRoleChecked() {
    this.role = '';
    if (this.roleChecked) {
      this.role = 'UserType';
    }
  }

  onCreationDateChecked() {
    this.creationDate = '';
    if (this.creationDateChecked) {
      this.creationDate = 'CreationDate';
    }
  }

  onNotesChecked() {
    this.notes = '';
    if (this.notesChecked) {
      this.notes = 'Notes';
    }
  }


  generateUserReportToExcel() {
    const params = new URLSearchParams();
    if (this.firstName !== undefined && this.firstName.length !== 0) {
      params.append('selection', this.firstName);
    }
    if (this.lastName !== undefined && this.lastName.length !== 0) {
      params.append('selection', this.lastName);
    }
    // if (this.contactName !== undefined && this.contactName.length !== 0) {
    //   params.append('selection', this.contactName);
    // }
    if (this.address1 !== undefined && this.address1.length !== 0) {
      params.append('selection', this.address1);
    }
    if (this.address2 !== undefined && this.address2.length !== 0) {
      params.append('selection', this.address2);
    }
    if (this.city !== undefined && this.city.length !== 0) {
      params.append('selection', this.city);
    }
    if (this.province !== undefined && this.province.length !== 0) {
      params.append('selection', this.province);
    }
    if (this.country !== undefined && this.country.length !== 0) {
      params.append('selection', this.country);
    }
    if (this.creationDate !== undefined && this.creationDate.length !== 0) {
      params.append('selection', this.creationDate);
    }
    if (this.postalCode !== undefined && this.postalCode.length !== 0) {
      params.append('selection', this.postalCode);
    }
    if (this.phone !== undefined && this.phone.length !== 0) {
      params.append('selection', this.phone);
    }
    if (this.fax !== undefined && this.fax.length !== 0) {
      params.append('selection', this.fax);
    }
    if (this.email !== undefined && this.email.length !== 0) {
      params.append('selection', this.email);
    }
    if (this.userName !== undefined && this.userName.length !== 0) {
      params.append('selection', this.userName);
    }
    if (this.authorities !== undefined && this.authorities.length !== 0) {
      params.append('selection', this.authorities);
    }
    if (this.role !== undefined && this.role.length !== 0) {
      params.append('selection', this.role);
    }
    if (this.notes !== undefined && this.notes.length !== 0) {
      params.append('selection', this.notes);
    }

    this.loading = true;
    this.isLoading = true;
    this.reportService.generateUserReport(params).subscribe(
      blob => {
        this.selectionRequired = blob.headers.get('selectionrequired');
        if (this.selectionRequired) {
        this.loading = false;
        this.isLoading = false;
        this.alertify.message(this.selectionRequired);
        } else {
          if (blob) {
            const link = document.createElement('a');
            if (window.navigator &&
              window.navigator.msSaveOrOpenBlob) { // for IE
              window.navigator.msSaveOrOpenBlob(blob.body, 'User' + `.xlsx`);
              this.loading = false;
              this.alertify.message('User report generation is complete');
          } else {
            link.href = window.URL.createObjectURL(blob.body);
            link.download = 'User';
            link.click();
            this.loading = false;
            this.alertify.message('User report generation is complete');
          }
          }
        }
      },
      error => {
        this.alertify.error('User report generation failed, please try again!');
        this.loading = false;
        this.isLoading = false;
      }
    );
  }

}
